import type { BoundNew } from '@eti/schema-types';
import { Heading, Stack } from '@etg/wings';
import { useSiteContext, useTranslation } from '@eti/providers';
import { getFinalSegments } from '../../../../result/components/v3/drawer/itinerary/utils';
import ItineraryDetailsLocationTime from '../../../../result/components/v3/drawer/itinerary/ItineraryDetailsLocationTime';
import type { BoundsType } from '../../../../result/models';
import { addLegendNumberToSegmentEvents } from '../../../../../widgets/trip-details/utils/format';

interface ItineraryInfoSectionProps {
  bounds: BoundNew[] | BoundsType;
}

export default function ItineraryInfoSection({ bounds = [] }: ItineraryInfoSectionProps) {
  const boundsWithLegends: BoundsType = addLegendNumberToSegmentEvents(bounds as BoundsType);
  const segments = getFinalSegments(boundsWithLegends as BoundsType);
  const { t } = useTranslation();
  const { partner } = useSiteContext();

  const headingText =
    t(`YourSelectedTrip.BookingFlow.PartnerName.${partner}`) ||
    t('YourSelectedTrip.Page.NoPartner.Heading');

  return (
    <Stack data-testid="your-selected-trip-page-itinerary-info-wrapper">
      <Heading level={3}>{headingText}</Heading>
      {segments.map((segment, index) => (
        <Stack key={index}>
          <ItineraryDetailsLocationTime
            arrivalCityCode={segment.destination?.cityCode}
            arrivalCode={segment.destination?.code ?? ''}
            arrivalDate={segment.arrivedAt as string}
            boundNumber={segment.boundNumber}
            brandedFareInformation={segment.brandedFareInformation}
            cabinClass={segment.cabinClassName}
            carriers={segment.allMarketingCarriers}
            departureCityCode={segment.origin?.cityCode}
            departureCode={segment.origin?.code ?? ''}
            departureDate={segment.departuredAt as string}
            duration={segment.totalDuration}
            isSelfTransfer={segment.isSelfTransfer}
            key={segment.segmentId}
            marketingCarrier={segment.marketingCarrier}
            numberOfTechnicalStops={segment.totalNumberOfTechnicalStops}
            stopoverType={segment.stopoverType}
            stops={segment.stops}
            trainSegment={segment.trainSegment}
          />
        </Stack>
      ))}
    </Stack>
  );
}
